import { render, staticRenderFns } from "./ManagerDesktop.vue?vue&type=template&id=315fae7a&"
import script from "./ManagerDesktop.vue?vue&type=script&lang=js&"
export * from "./ManagerDesktop.vue?vue&type=script&lang=js&"
import style0 from "./ManagerDesktop.vue?vue&type=style&index=0&lang=stylus&"


/* normalize component */
import normalizer from "!../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports